;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["tiered_comms", "comm_type"],
  data: function data() {
    return {
      tiered_commissions: [{ min: "", max: "", value: "" }],
      commission_type: ""
    };
  },
  mounted: function mounted() {
    this.tiered_commissions = JSON.parse(this.tiered_comms);
    this.commission_type = this.comm_type;
  },

  computed: {
    tiered_comm: function tiered_comm() {
      return (0, _stringify2.default)(this.tiered_commissions);
    }
  },
  methods: {
    add_commission: function add_commission() {
      this.tiered_commissions.push({ min: "", max: "", value: "" });
    },
    remove_commission: function remove_commission(index) {
      this.tiered_commissions.splice(index, 1);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9adc5b30", __vue__options__)
  } else {
    hotAPI.reload("data-v-9adc5b30", __vue__options__)
  }
})()}